import React from 'react'
import {InfoSection} from '../../Components'
import { HomeObj3} from './Data'
function Security(){
    return (
        <>
       
      <InfoSection {...HomeObj3}/>    
        </>
    )
}

export default Security